function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "awesome-facebook",
  "data-name": "Icon awesome-facebook",
  d: "M73.563,37.063a36.5,36.5,0,1,0-42.2,36.058V47.614H22.087V37.063h9.272V29.021c0-9.147,5.446-14.2,13.786-14.2a56.173,56.173,0,0,1,8.171.712v8.978h-4.6c-4.533,0-5.947,2.814-5.947,5.7v6.851H52.888L51.27,47.614h-8.5V73.121A36.513,36.513,0,0,0,73.563,37.063Z",
  transform: "translate(-0.563 -0.563)",
  fill: "#fff"
});

var SvgAwesomeFacebook = function SvgAwesomeFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 73,
    height: 72.558,
    viewBox: "0 0 73 72.558",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwesomeFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awesome-facebook.6aa9b364.svg";
export { ForwardRef as ReactComponent };